import { useState } from "react";
import axios from "axios";
import { API_BASE } from "../../lib/api";
import { Download, Loader2 } from "lucide-react";

export const ExportButton = ({ resource, filename, label }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const download = async () => {
    if (loading) return;
    setLoading(true);
    setError(false);
    try {
      const { data } = await axios.get(`${API_BASE}/api/export/${resource}.csv`, {
        withCredentials: true,
        responseType: "blob",
      });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      data-testid={`admin-export-${resource}`}
      onClick={download}
      disabled={loading}
      className="flex items-center gap-2 rounded-full border border-navy/15 bg-white px-4 py-2 text-xs font-semibold text-navy transition-colors hover:border-gold hover:text-gold-dark disabled:opacity-60"
    >
      {loading ? <Loader2 size={13} className="animate-spin" /> : <Download size={13} />}
      {error ? "Export impossible" : label}
    </button>
  );
};
